
    import Vue from "vue";

    const END_POINT = "/account-terminology";

    const getTerminologies = data => Vue.axios.get(END_POINT, {params: data});

    export {
      getTerminologies
    };
    